const axios = require('axios')

const orderClient = {
	postOrder(config, order) {
		return new Promise((resolve, reject) => {
			var uri = `${config.uri}api/orders`

			axios({
				method: 'POST',
				url: uri,
				headers: {
					'content-type': 'application/json; charset=utf-8',
					'x-tenant': config.tenant,
					'x-language': config.language,
					authorization: 'Bearer ' + config.access_token,
					'x-environment': config.env,
					'x-version': config.appVersion
				},
				data: order
			})
				.then(response => {
					resolve(response.data)
				})
				.catch(error => {
					reject(error)
				})
		})
	}
}

export { orderClient }
